import makeApi from '../client/api'
import { authenticateCrawlerConversion, connectFacebook } from './auth'

const finishSignup = async (
  announcementId,
  { source, sourceId, token },
  { data, facebookToken, conversionFrom },
) => {
  const { accessToken, user } = await authenticateCrawlerConversion(announcementId, {
    source,
    sourceId,
    token,
  })
  const { update, api, validateResponse } = makeApi({ token: accessToken })

  const convertCrawlerData = async () =>
    update('/announcements/raw', {
      id: announcementId,
      data: {
        approved: true,
        complete: true,
        converted: true,
        metadata: { conversion_from: conversionFrom },
      },
    })

  if (facebookToken) {
    const response = await connectFacebook(accessToken, facebookToken, true)
    validateResponse(response)
    await convertCrawlerData()

    return { user: response.data.user, access_token: accessToken }
  }

  const response = await api.patch('/profile', {
    ...user,
    ...data,
  })
  validateResponse(response)
  await convertCrawlerData()

  return { user: response.data.data, access_token: accessToken }
}

export default finishSignup
